import { startBenchmarks } from './start-benchmarks.action';
import { getChannels } from './get-channels.action';
import { getColorList } from './get-color-list.action';

export const actions = {
  startBenchmarks,
  getChannels,
  getColorList,
};
